import script from "./ActionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionItem.vue?vue&type=script&setup=true&lang=js"

import "./ActionItem.vue?vue&type=style&index=0&id=58e4165e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e4165e"]])

export default __exports__